import React , {useState , useEffect} from 'react';
import { Link  ,useNavigate } from 'react-router-dom';
import swal from 'sweetalert';


import logo1 from '../img/Logo.jpg';

// import { useSelector, useDispatch } from 'react-redux';


// import seoData from '../Pages/data';


const Header =(props)=> {

  const [total1 , settotal1] = useState(0)
    const [search , setSearch] = useState("")
    const [DataPart2 , setDataPart2] = useState([])
    const [UserDatat , setUserDatat] = useState({})
    const [userHeader , setuserHeader] = useState(false)
    const [menu1 , setmenu1] = useState(false)
    const [adminHeader , setadminHeader] = useState(false)
    const [displayMenu , setdisplayMenu] = useState(false)
    const [MainLine , setMainLine] = useState("")
    const [MainForum , setMainForum] = useState(false)
    const [MainCatogories , setMainCategories] = useState([])
    const [SubCategories , setSubCategories] = useState([])
    const [SubClassCategories , setSubClassCategories] = useState([])
    const [fvalue , setfvalue] = useState([])
    const [fvalue1 , setfvalue1] = useState([])
    const [fg , setfg] = useState(true)
    const [abc , setabc] = useState(false)
    const [DisplaySearch , setDisplaySearch] = useState(false)
    const [DisplayMenu , setDisplayMenu] = useState(false)
    const [bht , setbht] = useState("")
    const [mainUser , setmainUser] = useState({})
    const [couponShow1 , setcouponShow1] = useState(false)
    const [name, setname] = useState("") 
    const [email, setemail] = useState("") 
    const [message, setmessage] = useState("") 
    const [photo, setphoto] = useState("") 
    const [allmessage , setallmessage] = useState([])
    const [cart1 , setcart1] = useState([])
    const [fav1 , setfav1] = useState([])
    // const [photo, setphoto] = useState("") 
    const [AllPage , setAllPage] = useState([])
    // const [AllPage , setAllPage] = useState([...seoData])

    let history = useNavigate();


    useEffect(() =>{
      // document.getElementById("menu-mobile-1").style.transform = "translateX(280px)"
      // document.getElementById("menu-mobile-1").style.visibility = "hidden"
      // document.getElementById("menu-mobile-2").style.visibility = "hidden"


      var data1 =  JSON.parse(localStorage.getItem("Cart")) ?  JSON.parse(localStorage.getItem("Cart"))  : []
      var data2 =  JSON.parse(localStorage.getItem("Fav")) ?  JSON.parse(localStorage.getItem("Fav")) : []
      setcart1(data1)
      setfav1(data2)
      // let data5 =  JSON.parse(localStorage.getItem("CartPrice")) 
      // settotal1(data5)
      let j = 0 
      data1.map((item,i)=>{
        j = item.Total_Product_Price + j
     })
     settotal1(j)
        if( JSON.parse(localStorage.getItem("user main")) ) setmainUser(JSON.parse(localStorage.getItem("user main")))
        
        // fetch("https://malook-pk-front-back.vercel.app/Forum",{
        //     method: "GET",
        //      headers :  {
        //      "Content-Type" : "application/json" , 
        //  } ,
        // })
        // .then(res=>res.json())
        // .then(res1=>{
        //     console.log(res1[0]);
        //     setMainForum(res1[0].student)
        
        // })
        // fetch("https://malook-pk-front-back.vercel.app/CourseAllSubCategories",{
        //     method: "GET",
        //      headers :  {
        //      "Content-Type" : "application/json" , 
        //  } ,
        // })
        // .then(res2=>res2.json())
        // .then(res3=>{
        //     let data = res3.sort((a, b) => {
        //         return a.sort - b.sort;
        //     });
        //     console.log(data);
        //     setSubClassCategories(data)
        // })
        // fetch("https://malook-pk-front-back.vercel.app/AllCategories",{
        //     method: "GET",
        //      headers :  {
        //      "Content-Type" : "application/json" , 
        //  } ,
        // })
        // .then(res2=>res2.json())
        // .then(res3=>{
        //     // let dat1 = []
        //     // res3.map((res55,c)=>{
        //     //     dat1.push(0)
        //     // })
        //     // setfvalue1(dat1)
        //     // let data = res3.sort((a, b) => {
        //     //     return a.sort - b.sort;
        //     // });
        //     let unique_values = res3
        // .map((item) => item.CategoriesName)
        // .filter(
        //     (value, index, current_value) => current_value.indexOf(value) === index
        // );
        //     setSubCategories(unique_values)        
        // }) 

        // fetch("https://malook-pk-front-back.vercel.app/MainCatogories",{
        //     method: "GET",
        //      headers :  {
        //      "Content-Type" : "application/json" , 
        //  } ,
        // })
        // .then(res3=>res3.json())
        // .then(res4=>{
        //     let dat = []
        //     let dat1 = []
        //     res4.map((res55,c)=>{
        //         dat.push(res55)
        //         dat1.push(0)
        //     })
        //                 console.log(dat)
        //     let data = dat.sort((a, b) => {
        //         return a.sort - b.sort;
        //     });
        //     setMainCategories(data)
        //     console.log(data)
        //     setfvalue(dat1)
        // })
      //   fetch("https://malook-pk-front-back.vercel.app/AllUserShowMessage",{
      //     method: "GET",
      //      headers :  {
      //      "Content-Type" : "application/json" , 
      //  }
      // })
      // .then(res=>res.json())
      // .then(res1=>{
      //     setallmessage(res1)
      //     console.log(res1)
      //  const Chat1 = res1.filter((user,j)=>{
      //      if(JSON.parse( localStorage.getItem("Chat User Data"))){
      //          if(user.user_id === JSON.parse( localStorage.getItem("Chat User Data")).email ){
      //             return user
      //          }
      //          }
      //         })
      //         console.log(Chat1)
      //     setallmessage(Chat1)
      // })
        // if ( JSON.parse(localStorage.getItem("Admin")) ){
        //     setadminHeader(true)
        //     setuserHeader(false)
        //     setUserDatat([])
        // }
        // else if ( JSON.parse(localStorage.getItem("User"))  ){
        //     setuserHeader(true)
        //     setadminHeader(false)
        //     setUserDatat(JSON.parse(localStorage.getItem("User")))
        // }
        // else{
        //     setadminHeader(false)
        //     setUserDatat([])
        //     setuserHeader(false)

        // }
        const inter = setInterval(()=>{
        //     if ( JSON.parse(localStorage.getItem("Admin")) ){
        //     setadminHeader(true)
        //     setuserHeader(false)
        //     setUserDatat([])
        // }
        // else if ( JSON.parse(localStorage.getItem("User"))  ){
        //     setuserHeader(true)
        //     setadminHeader(false)
        //     setUserDatat(JSON.parse(localStorage.getItem("User")))
        // }
        // else{
        //     setadminHeader(false)
        //     setUserDatat([])
        //     setuserHeader(false)

        // }
      //   fetch("https://malook-pk-front-back.vercel.app/AllUserShowMessage",{
      //     method: "GET",
      //      headers :  {
      //      "Content-Type" : "application/json" , 
      //  }
      // })
      // .then(res=>res.json())
      // .then(res1=>{
      //     setallmessage(res1)
      //     console.log(res1)
      //  const Chat1 = res1.filter((user,j)=>{
      //      if(JSON.parse( localStorage.getItem("Chat User Data"))){
      //          if(user.user_id === JSON.parse( localStorage.getItem("Chat User Data")).email ){
      //             return user
      //          }
      //          }
      //         })
      //         console.log(Chat1)
      //     setallmessage(Chat1)
      // })
            var data1 =  JSON.parse(localStorage.getItem("Cart")) 
         if (data1) {
             setDataPart2(data1)
             setcart1(data1)
            //  const data = DataPart2.length  
            //  setDataPart2(data)
            }
         else setDataPart2(0)
            var data6 =  JSON.parse(localStorage.getItem("Fav")) 
         if (data6) {
             setfav1(data6)
            //  const data = DataPart2.length  
            //  setfav1(data)
            }
         else setfav1(0)

         if( JSON.parse(localStorage.getItem("user main")) ) setmainUser(JSON.parse(localStorage.getItem("user main")))
        
       

        },3000)
        
        return () => clearInterval(inter);
    },[])
  

    const changeFruit = (goto1) => {
      // setCurrentFruit(newFruit)
      // history.push(goto);
      window.location = goto1;
    }
    
    
    
    // function redirect(goto){
    //   if (goto != '') {
    //       props.history.push(goto)
    //       window.location = goto;
    //   }
    // }
    // document.getElementById('cat1').onchange = function(){
    //   var goto = this.value;
    //   redirect(goto);
      
    // };

    const SubmitData4534 = (e) =>{
      
      e.preventDefault()
      setDisplaySearch(true)
      console.log("df")
      setDisplayMenu3()
      localStorage.removeItem("SearchData")

          fetch("https://malook-pk-front-back.vercel.app/SearchProduct",{
                                  method: "POST",
                                  headers :  {
                                      "Content-Type" : "application/json" , 
                                  } ,
                                  body : JSON.stringify({
                                      search : search.toLowerCase() ,
      
                                  })
                              })
                              .then(res=>res.json())
                              .then((res1)=>{ 
                                setDisplaySearch(false)

                                  console.log(res1) 
                                  const SearchProductItem = []
                                  
                                  let search1 = search.split(" ")
                                res1.map((res2,i)=>{
                                    // console.log(res2)
                                    var Name = res2.Product_Name.toLowerCase().split(" ")
                                     var Title = res2.Product_Title.toLowerCase().split(" ")
                                    // console.log(Name , Title)
                                    for (let j = 0; j < search1.length; j++) {
                                      
                                      Name.map((res3,i)=>{
  
                                          if (res3 === search1[j].toLowerCase().trim()){
                                              SearchProductItem.unshift(res2)
                                          }
                                      })
                                      Title.map((res4,i)=>{
                                        if (res4 === search1[j].toLowerCase().trim()){
                                          SearchProductItem.unshift(res2)
                                        }
                                      })
                                    }
                                })
                                  console.log(SearchProductItem)    

                                  console.log(SearchProductItem,props)
                                  let uniq = [...new Set(SearchProductItem)];
      
                                  localStorage.setItem("SearchData" , JSON.stringify(uniq) )
                                  
                                  setTimeout(()=>{
                                      history.push("/search/product-item");
      
                                      // return <Redirect push to="/shop/search/product-item" /> 
                                      // props.history.push(`/shop/search/product-item`)
                                  },1000)   
                                  // localStorage.setItem("SearchData" , JSON.stringify(res1) )
                                  // props.history.push(`/shop/search/product-item`)
      
                                  
                          })
                          .catch(err=>{
                                                        setDisplaySearch(false)

                            swal("There is An Error")                  
                              }) 
      }






    const SubmitData45342 = (e) =>{
      e.preventDefault()
      console.log("df")
      setDisplaySearch(true)
      localStorage.removeItem("SearchData")
          fetch("https://malook-pk-front-back.vercel.app/SearchProduct",{
                                  method: "POST",
                                  headers :  {
                                      "Content-Type" : "application/json" , 
                                  } ,
                                  body : JSON.stringify({
                                      search : search.toLowerCase() ,
      
                                  })
                              })
                              .then(res=>res.json())
                              .then((res1)=>{ 
                                
                                console.log(res1) 
                                  const SearchProductItem = []
                                  
                                  let search1 = search.split(" ")
                                res1.map((res2,i)=>{
                                    // console.log(res2.Product_Name.toLowerCase().split(" "),res2.Product_Title.toLowerCase().split(" "),i)
                                    var Name = res2.Product_Name.toLowerCase().split(" ")
                                     var Title = res2.Product_Title.toLowerCase().split(" ")
                                    // console.log(Name , Title)
                                    for (let j = 0; j < search1.length; j++) {
                                      
                                      Name.map((res3,i)=>{
  
                                          if (res3 === search1[j].toLowerCase().trim()){
                                              SearchProductItem.unshift(res2)
                                          }
                                      })
                                      Title.map((res4,i)=>{
                                        if (res4 === search1[j].toLowerCase().trim()){
                                          SearchProductItem.unshift(res2)
                                        }
                                      })
                                    }
                                })
                                  console.log(SearchProductItem)    

                                  console.log(SearchProductItem,props)
                                  let uniq = [...new Set(SearchProductItem)];
      
                                  localStorage.setItem("SearchData" , JSON.stringify(uniq) )
                                  
                                  setDisplaySearch(false)
                                  setTimeout(()=>{
                                      history.push("/search/product-item");
      
                                      // return <Redirect push to="/shop/search/product-item" /> 
                                      // props.history.push(`/shop/search/product-item`)
                                  },1000)   
                                  // localStorage.setItem("SearchData" , JSON.stringify(res1) )
                                  // props.history.push(`/shop/search/product-item`)
      
                                  
                          })
                          .catch(err=>{
                            console.log(err)
                            swal("There is An Error")                  
                            setDisplaySearch(false)
                              }) 
      }

const ChangeCateUrl = (res) =>{
  console.log("sfsfd")
  history.push("/categories/"+res+"/all-products")
    
}




    const SubmitData = (e) =>{
        e.preventDefault()

        fetch("https://malook-pk-front-back.vercel.app/SearchProduct",{
                                method: "POST",
                                headers :  {
                                    "Content-Type" : "application/json" , 
                                } ,
                                body : JSON.stringify({
                                    search : search.toLowerCase() ,
   
                                })
                            })
                            .then(res=>res.json())
                            .then((res1)=>{ 
                                console.log(res1)    
                                // localStorage.setItem("SearchData" , JSON.stringify(res1) )
                                // props.history.push(`/shop/search/product-item`)

                                const SearchProductItem = []
                                let search1 = search.split(" ")
                                res1.map((res2,i)=>{
                                    // console.log(res2)
                                    var Name = res2.Product_Name.toLowerCase().split(" ")
                                     var Title = res2.Product_Title.toLowerCase().split(" ")
                                    // console.log(Name , Title)
                                    for (let j = 0; j < search.length; j++) {
                                      
                                      Name.map((res3,i)=>{
  
                                          if (res3 === search1[j].toLowerCase().trim()){
                                              SearchProductItem.unshift(res2)
                                          }
                                      })
                                      Title.map((res4,i)=>{
                                        if (res4 === search1[j].toLowerCase().trim()){
                                          SearchProductItem.unshift(res2)
                                        }
                                      })
                                    }
                                })
                                console.log(SearchProductItem,props)
                                let uniq = [...new Set(SearchProductItem)];

                                localStorage.setItem("SearchData" , JSON.stringify(uniq) )
                                
                                setTimeout(()=>{
                                    history.push("/shop/search/product-item");

                                    // return <Redirect push to="/shop/search/product-item" /> 
                                    // props.history.push(`/shop/search/product-item`)
                                },1000)
                        })
                        .catch(err=>{
                            // swal("There is An Error")                  
                            }) 
    }

    // const SubmitData4534 = () =>{

    //     fetch("https://malook-pk-front-back.vercel.app/SearchProduct",{
    //                             method: "POST",
    //                             headers :  {
    //                                 "Content-Type" : "application/json" , 
    //                             } ,
    //                             body : JSON.stringify({
    //                                 search : search.toLowerCase() ,
   
    //                             })
    //                         })
    //                         .then(res=>res.json())
    //                         .then((res1)=>{ 
    //                             console.log(res1)    
    //                             // localStorage.setItem("SearchData" , JSON.stringify(res1) )
    //                             // props.history.push(`/shop/search/product-item`)

    //                             const SearchProductItem = []
                                
    //                             res1.map((res2,i)=>{
    //                                 // console.log(res2)
    //                                 var Name = res2.Product_Name.toLowerCase().split(" ")
    //                                  var Title = res2.Product_Title.toLowerCase().split(" ")
    //                                 // console.log(Name , Title)
    //                                 Name.map((res3,i)=>{

    //                                     if (res3 === search.toLowerCase().trim()){
    //                                         SearchProductItem.unshift(res2)
    //                                     }
    //                                 })
    //                                 Title.map((res4,i)=>{
    //                                     if (res4 === search.toLowerCase().trim()){
    //                                         SearchProductItem.unshift(res2)
    //                                     }
    //                                 })
    //                             })
    //                             console.log(SearchProductItem,props)
    //                             let uniq = [...new Set(SearchProductItem)];

    //                             localStorage.setItem("SearchData" , JSON.stringify(uniq) )
                                
    //                             setTimeout(()=>{
    //                                 history.push("/shop/search/product-item");

    //                                 // return <Redirect push to="/shop/search/product-item" /> 
    //                                 // props.history.push(`/shop/search/product-item`)
    //                             },1000)
    //                     })
    //                     .catch(err=>{
    //                         // swal("There is An Error")                  
    //                         }) 
    // }

const setStateChangeMenu = ()=>{
    if(!displayMenu){
        setdisplayMenu(true)
        document.getElementById("mobile-site-hide-show11").style.display = "block"
    }
    else{
        setdisplayMenu(false)
        document.getElementById("mobile-site-hide-show11").style.display = "none"
    }

    


}

    // const basket = useSelector((state) => state.basket);
    
    
    
const setDisplayMenu3 =() =>{
  if(document.getElementById("menu-mobile-1").style.visibility === "hidden"){
    document.getElementById("menu-mobile-1").style.transform = "translateX(280px)"
    document.getElementById("menu-mobile-1").style.visibility = "visible"
    document.getElementById("menu-mobile-2").style.visibility = "visible"
  }
  else{
    document.getElementById("menu-mobile-1").style.transform = "translateX(280px)"
    document.getElementById("menu-mobile-1").style.visibility = "hidden"
    document.getElementById("menu-mobile-2").style.visibility = "hidden"
  }
}
    
    
const setChangeDrop =() =>{
 console.log("dffdf")
//  document.getElementsByClassName('dropdown-menu')[0].style.visibility = "hidden"
//  document.getElementsByClassName('dropdown-menu')[0].style.opacity = 1

    document.getElementById("drop-change").style.visibility = "hidden"
    document.getElementById("drop-change").style.opacity = 1

}
const setChangeDrop1 =() =>{
 console.log("dffdf")
//  document.getElementsByClassName('dropdown-menu')[0].style.visibility = "hidden"
//  document.getElementsByClassName('dropdown-menu')[0].style.opacity = 1

    // if(document.getElementById("drop-change").style.visibility === "hidden"){
      document.getElementById("drop-change").style.visibility = "visible"
      document.getElementById("drop-change").style.opacity = 1
    // }

}
        return (
            <>
       
<section id="top" className="bg_black pt-2 pb-2">
    <div className="container-xl">
      <div className="row top_1">
        <div className="col-md-3">
          {/* <div className="top_1l">
            <span className="d-inline-block col_green fs-1 lh-1 me-1">
              <i className="fa fa-location-arrow" />
            </span>
            <h6 className="mb-0 text-white d-inline-block fw-bold font_14">
              Email: <br />
              <a className="col_green a_tag1 fs-6" href="#">
                info@yovho.com
              </a>
            </h6>
          </div> */}
        </div>
        <div className="col-md-6">
          <div className="top_1m text-center">
            <p className="mb-0 text-light">
              50% Off Your Next Trip. Hurry Up For Your New Tour!{" "}
              <a className="col_green a_tag1" href="#">
                Book Your Tour
              </a>
            </p>
          </div>
        </div>
        <div className="col-md-3">
          <div className="top_1r text-end">
            <ul className="mb-0">
              <li className="d-inline-block">
                <a className="d-block text-center rounded-circle" href="https://www.facebook.com/yovho.official">
                  <i className="fa-brands fa-facebook" />
                </a>
              </li>
              <li className="d-inline-block ms-2">
                <a className="d-block text-center rounded-circle" href="https://www.tiktok.com/@yovho.official">
                  <i className="fa-brands fa-tiktok" />
                </a>
              </li>
              <li className="d-inline-block ms-2">
                <a className="d-block text-center rounded-circle" href="https://www.pinterest.com/yovho_official/">
                  <i className="fa-brands fa-pinterest" />
                </a>
              </li>
              <li className="d-inline-block ms-2">
                <a className="d-block text-center rounded-circle" href="https://www.instagram.com/yovho.official/">
                  <i className="fa-brands fa-instagram" />
                </a>
              </li>
              <li className="d-inline-block ms-2">
                <a className="d-block text-center rounded-circle" href="https://x.com/yovho_official">
                  <i className="fa-brands fa-twitter" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section id="header">
    <nav
      className="navbar navbar-expand-md navbar-light px_4"
      id="navbar_sticky"
    >
      <div className="container-fluid">
        <a className="navbar-brand  p-0 fw-bold" href="/">
           {/*  <i className="fa fa-plane-arrival col_green" /> {" "}
         
        <span style={{
            color : "#174c91;"
          }}> YOVHO</span>{" "} */}
          <img src={logo1} alt="Yovho Logo" style={{width : "130px",height:"50px"}}/>
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mb-0 ms-auto nav_1">
            {/* <li className="nav-item">
              <a
                className="nav-link active"
                aria-current="page"
                href="index.html"
              >
                HOTEL STAY
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="about.html">
                APARTMENT STAY{" "}
              </a>
            </li> */}
            {/* <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                GUEST HOUSE
              </a>
              <ul
                className="dropdown-menu drop_1"
                aria-labelledby="navbarDropdown"
              >
                <li>
                  <a className="dropdown-item" href="tour.html">
                    {" "}
                    Tour
                  </a>
                </li>
                <li>
                  <a className="dropdown-item border-0" href="detail.html">
                    {" "}
                    Tour Detail
                  </a>
                </li>
              </ul>
            </li> */}
            {/* <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Destination
              </a>
              <ul
                className="dropdown-menu drop_1"
                aria-labelledby="navbarDropdown"
              >
                <li>
                  <a className="dropdown-item" href="destination.html">
                    {" "}
                    Destination
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item border-0"
                    href="destination_detail.html"
                  >
                    {" "}
                    Destination Detail
                  </a>
                </li>
              </ul>
            </li> */}



   <li className="nav-item">
              <a className="nav-link" href="/">
                Hotels
              </a>
            </li>

   {/* <li className="nav-item">
              <a className="nav-link" href="contact.html">
                AIRPORT TAXI
              </a>
            </li> */}

   <li className="nav-item">
              <a className="nav-link" href="contact.html">
                Travel Guides
              </a>
            </li>

   <li className="nav-item">
              <a className="nav-link" href="contact.html">
                Blogs
              </a>
            </li>
   <li className="nav-item">
              <a className="nav-link" href="help/faqs">
                Help
              </a>
            </li>


   <li className="nav-item">
              <a className="nav-link" href="/join-us-partners"  style={
                {
    fontWeight: "700",
    fontSize: "15px",
                }
              }>
                List your  Property
              </a>
            </li>



            {/* <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Blog
              </a>
              <ul
                className="dropdown-menu drop_1"
                aria-labelledby="navbarDropdown"
              >
                <li>
                  <a className="dropdown-item" href="blog.html">
                    {" "}
                    Blog
                  </a>
                </li>
                <li>
                  <a className="dropdown-item border-0" href="blog_detail.html">
                    {" "}
                    Blog Detail
                  </a>
                </li>
              </ul>
            </li> */}
            {/* <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Pages
              </a>
              <ul
                className="dropdown-menu drop_1"
                aria-labelledby="navbarDropdown"
              >
                <li>
                  <a className="dropdown-item" href="gallery.html">
                    {" "}
                    Gallery
                  </a>
                </li>
                <li>
                  <a className="dropdown-item border-0" href="faq.html">
                    {" "}
                    Faq
                  </a>
                </li>
              </ul>
            </li> */}
            {/* <li className="nav-item">
              <a className="nav-link" href="contact.html">
                GUEST HOUSE
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="contact.html">
                HOSTELS
              </a>
            </li> */}
            {/* <li className="nav-item">
              <a className="nav-link" href="contact.html">
                AIRPORT TAXI
              </a>
            </li> */}

              <li className="nav-item">
              <a className="nav-link" href="/login" style={
                {
                  border: '2px solid #002776',
    borderRadius: '27px',
    fontWeight: "700",
    fontSize: "15px"
                }
              }>
                Login
              </a>
            </li>

            {/* <li className="nav-item">
              <a className="nav-link" href="contact.html">
                Contact
              </a>
            </li> */}
          </ul>
          <ul className="navbar-nav mb-0 ms-auto nav_2">
            {/* <li className="nav-item">
              <a className="nav-link fs-4" href="#">
                <i className="fa fa-user" />
              </a>
            </li> */}
           
            <li className="nav-item">
              <a className="nav-link fs-4 drop_icon col_green" href="#">
                <i className="fa fa-phone" />
              </a>
            </li>
            <li className="mb-0  d-inline-block fw-bold font_14 nav-item" style={{color:"#002776"}} >
              Call Us to Book Now
              <br />
              <a className="col_green a_tag1 fs-5" href="#">
                +92 31 666 111 36
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </section>

        </>
        )
}

export default Header;
